import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const Dashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    fetch('/api/super-admin/stats', {
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    })
      .then((r) => r.json())
      .then((data) => setStats(data))
      .catch((e) => console.error(e))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="p-4 md:p-6 max-w-7xl mx-auto">
      <h1 className="text-2xl md:text-3xl font-bold text-[#2C3E50] mb-2">🎯 Espace Super Admin</h1>
      <p className="text-gray-600 mb-6 md:mb-8 text-sm md:text-base">Vue d'ensemble de tous les établissements.</p>

      {loading ? (
        <div className="text-center py-20 text-gray-500">Chargement...</div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5 mb-8">
          {[
            { label: 'Établissements', value: stats?.total_establishments, icon: '🏫', color: 'orange' },
            { label: 'Élèves', value: stats?.total_students, icon: '🎓', color: 'blue' },
            { label: 'Professeurs', value: stats?.total_teachers, icon: '👨‍🏫', color: 'green' },
            { label: 'Admins', value: stats?.total_admins, icon: '👤', color: 'purple' },
          ].map((card, i) => (
            <div key={i} className="bg-white rounded-2xl p-4 md:p-6 shadow-md border border-gray-100">
              <div className="text-2xl md:text-3xl mb-2 md:mb-3">{card.icon}</div>
              <div className="text-xl md:text-3xl font-bold text-[#2C3E50]">{card.value ?? 0}</div>
              <div className="text-xs md:text-sm text-gray-500 mt-1">{card.label}</div>
            </div>
          ))}
        </div>
      )}

      {/* Boutons : en colonne sur mobile, en ligne sur PC */}
      <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
        <Link
          to="/super-admin/establishments/new"
          className="w-full sm:w-auto text-center bg-[#F39C12] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#E67E22] transition"
        >
          ➕ Créer un lycée
        </Link>
        <Link
          to="/super-admin/establishments"
          className="w-full sm:w-auto text-center border border-gray-300 text-gray-700 px-6 py-3 rounded-lg font-semibold hover:bg-gray-50 transition"
        >
          📋 Liste des lycées
        </Link>
      </div>
    </div>
  );
};

export default Dashboard;